import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function verify(secret) {
  const axios = axiosInstance().primoLab;
  let data = {};

  await axios
    .post("/2fa/verify", {
      secret,
    })
    .then(async (response) => {
      data = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data;
    });

  return { data };
}
